import React from "react";
import OrdersListModal from "./OrdersListModal";

export default function InvoiceOrdersModal(props) {
  return (
    <OrdersListModal
      title="Zlecenia do Fakturowania"
      variant="invoice"
      primaryLabel="Zamknij"    // (zamknięcie po fakturowaniu – zgodnie z Twoją logiką)
      emptyText="Brak zleceń do fakturowania."
      {...props}
    />
  );
}
